import { Checkbox, ComboBox, Dropdown, IComboBoxOption, Icon, IDropdownOption, Link, ProgressIndicator, Stack, TextField, Toggle, TooltipHost, useTheme } from '@fluentui/react';
import * as React from 'react';
import { IAttendeeRegistrationListItemSelected } from '../../../../../Models/Event/IAttendeeRegistrationListItem';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';
import { formatUrl } from '../../../../../Services/API/ApiHelpers';
import { backendUrl } from '../../../../../Services/ConfigureService';
import { zdravotniPojistovny } from '../../../../Attendees/AttendeeDetail/AttendeeDetailForm';
import { InvoiceList } from '../../../Invoices/InvoiceList/InvoiceList';

interface IAttendeeRegistrationDetailViewProps {
    isLoading: boolean;
    item?: IAttendeeRegistrationListItemSelected;
    propertyChanged: (key: string, value: any) => void;
    createInvoice: (semester: number) => void;
    sendRegistrationByEmail: (registrationId: number) => void;
    profile: IUserProfile,
}
const odchod: IComboBoxOption[] = [
    {
        key: "samostatně",
        text: "samostatně",
    },
    {
        key: "v doprovodu",
        text: "v doprovodu",
    }
]

export const AttendeeRegistrationDetailView: React.FunctionComponent<IAttendeeRegistrationDetailViewProps> = (props) => {

    
    const theme = useTheme(); 

    const propertyChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }

    const onPriceType = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        props.propertyChanged("priceType", option!.key as number);
    }

    const isSubstituteChanged = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        props.propertyChanged("isSubstitute", checked?true:false );
    }
    const isActiveChanged = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        props.propertyChanged("isActive", checked ? true : false);
    }
    const acceptPromotionChanged = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        props.propertyChanged("acceptPromotion", checked ? true : false);
    }
    const acceptMarketingChanged = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        props.propertyChanged("acceptMarketing", checked ? true : false);
    }


    const renderInvoice = (invoces?: string) => {
        if (invoces && invoces != "") {
            const items = invoces.split(",").filter((v, i, a) => a.indexOf(v) === i);
            return <Stack horizontal tokens={{ childrenGap: 0 }}>
                Faktura(y):
                {items.map((item, index, a) => {
                    return <Link styles={{ root: { paddingLeft: 2 } }}>{item + (index < a.length - 1 ? "," : "")}</Link>
                })}
            </Stack>
        }
        return null
    }

    const renderPrice = (price: number, paid: number, semester: number, invoices?: string, isOverdue?: boolean, canCreateInvoice?: boolean) => {
        return (<>{props.profile.isAdmin ? <Stack>
            <TextField id={semester === 0 ? "price" : semester === 1 ? "firstSemesterPrice" : "secondSemesterPrice"} key="firstSemesterPrice" label="1 pololetí" disabled={props.isLoading} value={price ? price.toString() : "0"}
                onChange={propertyChanged} />
            <Stack horizontal>
                {renderInvoice(invoices)}
                {invoices ?
                    (price > paid ?
                        isOverdue ?
                            <Icon iconName="Cancel" title="Nezapalaceno po splatnosti" styles={{ root: { color: theme.semanticColors.errorIcon, fontWeight: 400, fontSize: theme.fonts.medium.fontSize } }} />
                            : null
                        :
                        (price != 0 && paid != 0 && price <= paid) ?
                            <Icon iconName="CheckMark" title="Zaplaceno" styles={{ root: { color: theme.semanticColors.successIcon, fontWeight: 400, fontSize: theme.fonts.medium.fontSize } }} />
                            : null)
                    : null}
            </Stack>
            {canCreateInvoice && (props.profile.isAccountant || props.profile.isAdmin) ? <Link onClick={() => props.createInvoice(semester)}>Vytvoř fakturu</Link> : null}
        </Stack> : null}</>)
    }



    return (<Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>
        {props.isLoading ? <ProgressIndicator /> : null}
        <Stack horizontal tokens={{ childrenGap: 15 }}>
            <Toggle disabled={!props.profile.isAdmin} label="Aktivní přihláška" onText="Ano" offText="Ne" onChange={isActiveChanged} checked={props.item?.isActive} />
            <Toggle disabled={!props.profile.isAdmin} onText="Ano" offText="Ne" label="Jako náhradník" onChange={isSubstituteChanged} checked={props.item?.isSubstitute} />
        </Stack>
        <Stack horizontal tokens={{ childrenGap: 15 }}>
            <Toggle disabled={!props.profile.isAdmin} label="Propagační aktivity" onText="Ano" offText="Ne" onChange={acceptPromotionChanged} checked={props.item?.acceptPromotion} />
            <Toggle disabled={!props.profile.isAdmin} label="Souhlas pro přímý marketing" onText="Ano" offText="Ne" onChange={acceptMarketingChanged} checked={props.item?.acceptMarketing} />
        </Stack>

        <ComboBox disabled={!props.profile.isAdmin}  styles={{ root: { width: 140 } }} selectedKey={props.item?.doprovod} onChange={(e, o, i, v) => props.propertyChanged("doprovod", o?.key ? o?.key : "")} options={odchod}
            label="Po skončení bude odcházet" />

        <ComboBox label="Zdravotní pojišťovna" options={zdravotniPojistovny} disabled selectedKey={props.item?.insurance} onChange={(e, o, i, v) => {
            props.propertyChanged("insurance", o?.key);
        }} />

        <TextField readOnly={!props.profile.isAdmin || props.isLoading} id="medicalNotes" key="medicalNotes" label="Poznámky ke zdravotnímu stavu, jiné" multiline />

        {props.profile.isAdmin ?
            <Stack grow>
                <Dropdown onChange={onPriceType} selectedKey={props.item?.priceType} styles={{ root: { minWidth: 185 } }} label="Cena za" options={[{ key: 0, text: "Akci" }, { key: 1, text: "Pololetí" }]} />
            </Stack> : null}
        {props.item?.priceType === 0 ?
            <Stack horizontal grow>
                {renderPrice(props.item.price,
                    props.item.firstSemesterPriceInvoicePaidTotal ? props.item.firstSemesterPriceInvoicePaidTotal:0,
                    0,
                    props.item.priceInvoices,                    
                    props.item.priceInvoiceIsOverdue,
                    props.item.canCreatePriceInvoice
                )}
            </Stack> : null}

        {props.item?.priceType === 1 ?
            <Stack horizontal grow tokens={{ childrenGap: 10 }}>
                {renderPrice(props.item.firstSemesterPrice,
                    props.item.firstSemesterPriceInvoicePaidTotal ? props.item.firstSemesterPriceInvoicePaidTotal:0,
                    1,
                    props.item.firstSemesterPriceInvoices,                    
                    props.item.firstSemesterPriceInvoiceIsOverdue,
                    props.item.canCreateFirstPriceInvoice
                )}
                {renderPrice(props.item.secondSemesterPrice,
                    props.item.secondSemesterPriceInvoicePaidTotal ? props.item.secondSemesterPriceInvoicePaidTotal:0,
                    2,
                    props.item.secondSemesterPriceInvoices,
                    props.item.secondSemesterPriceInvoiceIsOverdue,
                    props.item.canCreateSecondPriceInvoice
                )}
            </Stack> : null}
        {props.profile.isAdmin?
            <Stack horizontal tokens={{ childrenGap: 15 }}>
            <Link target="_black" href={formatUrl(backendUrl(), `/api/pdf/GetApplication?id=` + props.item?.id)} onClick={() => { }}>Stáhnout přihlášku</Link>
            <Link onClick={() => { props.item?.id && props.sendRegistrationByEmail(props.item.id) }}>Odeslat přihlášku emailem</Link>
        </Stack> : null}
    </Stack>)
}
